module.exports = __webpack_public_path__ + "static/media/coloredLogo.aa499d13.svg";